
//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

export const welfareconfig = {
    programme: {
        service: {
            name: 'programme',
            title: 'Programmes',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['rid', 'pgn', 'pnm', 'pgc', 'ptn', 'pcn', 'pci', 'pti', 'lcn', 'ped', 'psd', 'fnm', 'pct', 'sti', 'ptg', 'snm', 'sts', 'ast'],
            params: { pgn: 'ProgNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['pgn', 'ProgNo'], ['pnm', 'Name'], ['pgc', 'Code'], ['ptn', 'Type'], ['pcn', 'Category'], ['lcn', 'Location'], ['psd', 'Start Date'], ['ped', 'End Date'], ['fnm', 'Fund'], ['pct', 'Cost'], ['ptg', 'Target'], ['snm', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'pgn', label: 'Programme No', type: 'tf', req: 1, ops: {} },
                { id: 'pnm', label: 'Programme Name', type: 'tf', req: 1, ops: {} },
                { id: 'pgc', label: 'Programme Code', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
                { id: 'pti', label: 'Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'programmetype' } },
                { id: 'pci', label: 'Category', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'programmecategory' } },
                { id: 'lci', label: 'Location', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'location' } },
                { id: 'psd', label: 'Start Date', type: 'df', req: 1, ops: {} },
                { id: 'ped', label: 'End Date', type: 'df', req: 1, ops: {} },
                { id: 'fid', label: 'Fund', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'fund' } },
                { id: 'pct', label: 'Cost', type: 'nf', req: 1, ops: {} },
                { id: 'ptg', label: 'Target', type: 'nf', req: 1, ops: {} },
                { id: 'sti', label: 'Status', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'programmestatus' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    issue: {
        service: {
            name: 'issue',
            title: 'Issues',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['mno', 'Meter No'], ['sno', 'STS No'], ['mtc', 'Type'], ['mph', 'Phase'], ['msc', 'Meter Status'], ['bat', 'Batch'], ['ssc', 'State'], ['ast', 'Status'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'mno', label: 'meter No', type: 'rf', req: 1, ops: {} },
                { id: 'sno', label: 'STS No', type: 'rf', req: 1, ops: {} },
                { id: 'mtc', label: 'Type', type: 'rf', req: 1, ops: {} },
                { id: 'mph', label: 'Phase', type: 'rf', req: 1, ops: {} },
                { id: 'msc', label: 'Status', type: 'rf', req: 1, ops: {} },
                { id: 'bat', label: 'Batch', type: 'rf', req: 1, ops: {} },
                { id: 'ssc', label: 'State', type: 'rf', req: 1, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { view: 'View' },
        panels: { view: 'simple' },
        formatters: { grid: { exi: fjd } }
    },
    requestform: {
        service: {
            name: 'requestform',
            title: 'Request Forms',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['mno', 'Meter No'], ['sno', 'STS No'], ['mtc', 'Type'], ['mph', 'Phase'], ['msc', 'Meter Status'], ['bat', 'Batch'], ['ssc', 'State'], ['ast', 'Status'], ['stp', 'Stamp']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'mno', label: 'meter No', type: 'rf', req: 1, ops: {} },
                { id: 'sno', label: 'STS No', type: 'rf', req: 1, ops: {} },
                { id: 'mtc', label: 'Type', type: 'rf', req: 1, ops: {} },
                { id: 'mph', label: 'Phase', type: 'rf', req: 1, ops: {} },
                { id: 'msc', label: 'Status', type: 'rf', req: 1, ops: {} },
                { id: 'bat', label: 'Batch', type: 'rf', req: 1, ops: {} },
                { id: 'ssc', label: 'State', type: 'rf', req: 1, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { view: 'View' },
        panels: { view: 'simple' },
        formatters: { grid: { exi: fjd } }
    },
    announcement: {
        service: {
            name: 'announcement',
            title: 'App Notification / Announcements',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['tle', 'Title'], ['acd', 'Date'], ['atn', 'Type'], ['amg', 'Message'],  ['dcd', 'Date Created'], ['ast', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'tle', label: 'Title', type: 'tf', req: 1, ops: {} },
                { id: 'acd', label: 'Date', type: 'df', req: 1, ops: {} },
                { id: 'amg', label: 'Message', type: 'tf', req: 1, ops: {} },
                { id: 'ati', label: 'Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'announcementtype' } },
                { id: 'cnt', label: 'Contact', type: 'tf', req: 0, ops: {} },
                // { id: 'cli', label: 'Class', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'classcombo' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    notification: {
        service: {
            name: 'notification',
            title: 'Notifications',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['tle', 'Title'], ['acd', 'Date'], ['atn', 'Type'], ['amg', 'Message'], ['cln', 'Class'], ['dcd', 'Date Created'], ['ast', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'tle', label: 'Title', type: 'tf', req: 1, ops: {} },
                { id: 'acd', label: 'Date', type: 'df', req: 1, ops: {} },
                { id: 'amg', label: 'Message', type: 'tf', req: 1, ops: {} },
                { id: 'ati', label: 'Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'announcementtype' } },
                { id: 'cnt', label: 'Contact', type: 'tf', req: 1, ops: {} },
                { id: 'cli', label: 'Class', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'classcombo' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
}
